import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

const CART_BLOCK = '.js-cart-block'

export default class extends Controller {
  async submit() {
    const response = await post(this.element.action, {
      body: new FormData(this.element),
      responseKind: 'html'
    })

    if (!response.ok) return

    this.#refreshCart(await response.html)
  }

  #refreshCart(html) {
    const current = document.querySelector(CART_BLOCK)
    if (!current) return

    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(CART_BLOCK)
    if (fresh) current.innerHTML = fresh.innerHTML
  }
}
